import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 26 26"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "#A0A0A0",
      d: "M19.094 1.516C17.74 1.204 15.515 1 13 1s-4.74.204-6.094.516a6.99 6.99 0 0 0-5.39 5.39C1.204 8.26 1 10.485 1 13s.204 4.74.516 6.094a6.99 6.99 0 0 0 5.39 5.39C8.26 24.796 10.485 25 13 25s4.74-.204 6.094-.516a6.99 6.99 0 0 0 5.39-5.39C24.796 17.74 25 15.515 25 13s-.204-4.74-.516-6.094a6.99 6.99 0 0 0-5.39-5.39Z"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#A0A0A0", d: "M9.5 12.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z" }),
  /* @__PURE__ */ React.createElement("circle", { cx: 7, cy: 9, r: 1, fill: "#A0A0A0" }),
  /* @__PURE__ */ React.createElement("circle", { cx: 19, cy: 9, r: 1, fill: "#A0A0A0" })
);
var SvgSentimentNeutralOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SentimentNeutralOutlined_default = SvgSentimentNeutralOutlined;

export { SentimentNeutralOutlined_default as default };
